// src/pages/ebilling/TermPage.js
import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  Container,
  Box,
  Button,
  Typography,
  Paper,
  Stack,
} from "@mui/material";


const EBillingTermPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [customerId, setCustomerId] = useState("");

  useEffect(() => {
    const state = location.state;
    const params = new URLSearchParams(location.search);
    const customerIdFromUrl = params.get("customerId");
    if (state) {
      setCustomerId(state.customerId || customerIdFromUrl || "");
    } else {
      setCustomerId(customerIdFromUrl || "");
    }
  }, [location.state, location.search]);
  const handleConfirmConsent = async () => {
    // ตรวจสอบว่าผู้ใช้เลื่อนอ่านจนจบหรือยัง
    navigate(`/close?customerId=${customerId}&status=true`);
  };

  return (
    <Container
      component="main"
      maxWidth="sm"
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
        p: 2,
      }}
    >
      <Paper
        elevation={0}
        sx={{
          borderRadius: 3,
          width: "100%",
          maxWidth: 450,
          minHeight: 800,
          boxSizing: "border-box",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          overflow: "hidden",
          backgroundColor: "white",
        }}
      >
        {/* Logo and Header Section */}
        <Box
          sx={{
            width: "100%",
            bgcolor: "white",
            p: 3,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
          }}
        >
          <Box
            component="img"
            src="/image/logo-header.png"
            alt="SG CAPITAL"
            sx={{
              height: 60,
              mb: 2,
              objectFit: "contain",
            }}
          />
          <Typography
            variant="h5"
            component="h1"
            sx={{
              fontWeight: 500,
              color: "#666666",
              fontSize: "1.5rem",
            }}
          >
            Verify Email
          </Typography>
        </Box>
        <Typography
          variant="h6"
          sx={{
            fontWeight: 600,
            color: "#333",
            fontSize: "1.3rem",
            textAlign: "center",
            mt: -1, // Move title up by 1cm equivalent (approximately -1 in Material-UI spacing)
            mb: 2,
          }}
        >
          ข้อตกลงการรับสิทธิพิเศษ
        </Typography>

        {/* Form Content - Takes remaining space */}
        <Box
          sx={{
            p: 5,
            pt: 2, // Reduced top padding to move title up
            width: "100%",
            flex: 1,
            display: "flex",
            flexDirection: "column",
          }}
        >
          {/* Content Area - Grows to fill space */}
          <Box sx={{ flex: 1, display: "flex", flexDirection: "column" }}>
            <Stack spacing={3} sx={{ width: "100%", flex: 1 }}>
              {/* Consent Content */}
              <Box
                sx={{
                  flex: 1,
                  border: "1px solid #e0e0e0",
                  borderRadius: 2,
                  overflow: "hidden",
                  backgroundColor: "#f8f9fa",
                }}
              >
                <Box
                  sx={{
                    height: 380,
                    overflowY: "auto",
                    p: 3,
                    fontSize: "0.95rem",
                    lineHeight: 1.6,
                    color: "#333",
                    "&::-webkit-scrollbar": {
                      width: "8px",
                    },
                    "&::-webkit-scrollbar-track": {
                      backgroundColor: "#f1f1f1",
                      borderRadius: "4px",
                    },
                    "&::-webkit-scrollbar-thumb": {
                      backgroundColor: "#c1c1c1",
                      borderRadius: "4px",
                      "&:hover": {
                        backgroundColor: "#a8a8a8",
                      },
                    },
                  }}
                >
                  <div>
                    *สิทธิพิเศษสำหรับลูกค้าสินเชื่อฯ ภายใต้บริษัท เอสจี แคปปิตอล
                    จํากัด (มหาชน) สมัครรับเอกสาร ใบแจ้งหนี้ ใบเสร็จรับเงิน
                    ใบกำกับภาษี และเอกสารอื่นๆ ในรูปแบบอิเล็กทรอนิกส์ รับ J
                    Point 300 คะแนน จำนวน 2,000 สิทธิ์ต่อเดือน
                    สมัครก่อนมีสิทธิก่อน หรือจนกว่าสิทธิ์จะหมด
                    โดยคะแนนจะโอนเข้าภายในสิ้นเดือน และสมัครหลังวันที่ 25
                    คะแนนจะโอนเข้าภายในเดือนถัดไป ระยะเวลาร่วมกิจกรรม 1 มีนาคม -
                    31 ธันวาคม 2569
                  </div>
                </Box>
              </Box>
            </Stack>
          </Box>

          {/* Action Buttons */}
          <Box sx={{ mt: 3 }}>
            {/* Confirm Button */}
            <Button
              onClick={handleConfirmConsent}
              fullWidth
              variant="contained"
              sx={{
                mb: 2,
                py: 2.5,
                borderRadius: 3,
                fontSize: "1.2rem",
                fontWeight: 500,
                textTransform: "none",
                backgroundColor: "#1976d2",
                color: "white",
                "&:hover": {
                  backgroundColor: "#1565c0",
                },
                "&:disabled": {
                  backgroundColor: "#e0e0e0",
                  color: "#a0a0a0",
                },
              }}
            >
              ยินยอม
            </Button>
          </Box>
        </Box>
      </Paper>
    </Container>
  );
};

export default EBillingTermPage;
